/** Resolve a public-folder path using Vite's base URL (e.g. "/app/" in prod, "/" in dev). */
export const assetUrl = (path: string) =>
  `${import.meta.env.BASE_URL}${path.replace(/^\//, '')}`
